var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogReportPaid__Component" }, [
    _c("div", { staticClass: "modal-card", staticStyle: { width: "1200px" } }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v("היסטוריית עריכה לשאלה: " + _vm._s(_vm.name)),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _vm.isLoading
        ? _c("div", { staticClass: "modal-card-body loading-container" }, [
            _c("p", { staticClass: "loading-text" }, [
              _vm._v("טוען היסטוריית עריכות..."),
            ]),
          ])
        : _c("section", { staticClass: "modal-card-body" }, [
            _c("div", { staticClass: "question-info" }, [
              _c("p", [
                _vm._v(" השאלה נוצרה על ידי: "),
                _c("span", { staticClass: "question-info-value" }, [
                  _vm._v(_vm._s(_vm.creatorUser)),
                ]),
              ]),
              _c("p", [
                _vm._v(" תאריך יצירה: "),
                _c("span", { staticClass: "question-info-value" }, [
                  _vm._v(_vm._s(_vm.parseDate(_vm.createdDate))),
                ]),
              ]),
            ]),
            _vm.appearances.length
              ? _c(
                  "table",
                  { attrs: { id: "customers" } },
                  [
                    _vm._m(0),
                    _vm._l(_vm.appearances, function (appearance, idx) {
                      return _c("tr", { key: idx, staticClass: "row" }, [
                        _c("td", { staticClass: "column-item" }, [
                          _vm._v(_vm._s(_vm.parseDate(appearance.createdDate))),
                        ]),
                        _c("td", { staticClass: "column-item" }, [
                          _vm._v(_vm._s(appearance.name)),
                        ]),
                      ])
                    }),
                  ],
                  2
                )
              : _c("div", [_vm._v("אין היסטוריית עריכות לשאלה זו")]),
          ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "סגור" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [_c("th", [_vm._v("בתאריך")]), _c("th", [_vm._v("פעולה")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }